import { _request, APIBaseResponse, APIMethod } from '../index';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const PACKAGES_PATH_PREFIX = 'packages';
const RALS_PATH_PREFIX = 'rals';

export type ProductPackageRal = {
    tenantId: string;
    productPackageId: string;
    aclResourceId: string;
    aclName: string;
    aclDisplayName: string;
    accessId: string;
    accessName: string;
};

type APIProductPackageRalsListParams = RequestParamsBase & {
    tenantId: string;
    productPackageId: string;
};

export type APIProductPackageRalsListResponse = APIBaseResponse<ProductPackageRal[]>;

export type APIProductPackageRalPostParams = RequestParamsBase & {
    tenantId: string;
    productPackageId: string;
    aclResourceId: string;
    accessId: string;
};

export type APIProductPackageRalDeleteParams = RequestParamsBase & {
    tenantId: string;
    productPackageId: string;
    aclResourceId: string;
    accessId: string;
};

export const APIProductPackageRalsGetList: APIMethod<APIProductPackageRalsListParams, APIProductPackageRalsListResponse> = (params: APIProductPackageRalsListParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PACKAGES_PATH_PREFIX}/${params.productPackageId}/${RALS_PATH_PREFIX}`, undefined, params.signal)
);

export const APIProductPackageRalPost: APIMethod<APIProductPackageRalPostParams, APIBaseResponse> = (params: APIProductPackageRalPostParams) => (
    _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PACKAGES_PATH_PREFIX}/${params.productPackageId}/${RALS_PATH_PREFIX}`, {
        tenantId: params.tenantId,
        productPackageId: params.productPackageId,
        aclResourceId: params.aclResourceId,
        accessId: params.accessId,
    }, params.signal)
);

export const APIProductPackageRalDelete: APIMethod<APIProductPackageRalDeleteParams, APIBaseResponse> = (params: APIProductPackageRalDeleteParams) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PACKAGES_PATH_PREFIX}/${params.productPackageId}/${RALS_PATH_PREFIX}/${params.aclResourceId}?accessId=${params.accessId}`, undefined, params.signal)
);
